import { Grid, Typography } from "@mui/material";
import { formatShiftSummaryLabel } from "../utils";
import { ShiftSummary } from "../types/editOrder";

type Props = {
  title?: string;
  items: ShiftSummary[];
  maxHeight?: number | string;
  paddingLeft?: number | string;
  formatItem?: (item: ShiftSummary) => string;
};

export const OrderShiftList = ({
  title,
  items,
  maxHeight = "unset",
  paddingLeft = 3,
  formatItem = (item) =>
    formatShiftSummaryLabel(item.start, item.end, item.locationName || ""),
}: Props) => {
  if (!items.length) return null;

  const talentName = items.find((item) => item.talentName)?.talentName;

  return (
    <Grid item xs={12}>
      {title ? (
        <Typography
          sx={{ marginBottom: "6px", fontSize: "20px", fontWeight: 600 }}
        >
          {title}
        </Typography>
      ) : null}
      <Grid item xs={12} pl={paddingLeft} sx={{ maxHeight, overflowY: "auto" }}>
        {!!talentName ? (
          <Typography variant="secondary" mb={0.5}>
            {talentName}
          </Typography>
        ) : null}
        {items.map((item) => (
          <Typography key={item.id}>{formatItem(item)}</Typography>
        ))}
      </Grid>
    </Grid>
  );
};
